// These represent the possible types of ALICE message IDs.
// Contextual is used for out-of-course messages.
const exported = {
  COURSE_BRANCH: 'courseBranch',
  ITEM: 'item',
  WEEK: 'week',
  CONTEXTUAL: 'contextual',
};

export default exported;

export const { COURSE_BRANCH, ITEM, WEEK, CONTEXTUAL } = exported;
